
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.958 1.208a.709.709 0 00-.708.709v.708h-.708a1.42 1.42 0 00-1.417 1.417v9.916c0 .78.638 1.417 1.417 1.417h9.916a1.42 1.42 0 001.417-1.417V4.042a1.42 1.42 0 00-1.417-1.417h-.708v-.708a.709.709 0 00-1.417 0v.708H5.667v-.708a.709.709 0 00-.709-.709zM3.542 6.167h9.916v7.791H3.542V6.167zm6.375 3.541a.709.709 0 00-.709.709v1.416c0 .391.318.709.709.709h1.416a.709.709 0 00.709-.709v-1.416a.709.709 0 00-.709-.709H9.917z","fill":"#667187"}})])
          )
        }
      }
    